import {TuiLanguageCommerce} from '@taiga-ui/i18n/interfaces';

export const TUI_DANISH_LANGUAGE_ADDON_COMMERCE: TuiLanguageCommerce = {
    cardNumber: [`Nummer`, `Kortnummer`],
    cardExpiry: [`Udløber`, `Gyldig til`],
};
